"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _unmutable = _interopRequireDefault(require("./internal/unmutable"));

var _toJSON = _interopRequireDefault(require("./toJSON"));

var _default = (0, _unmutable["default"])({
  name: 'shallowToJS',
  all: _toJSON["default"]
});

exports["default"] = _default;